import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const PageRoot = lazy(() => import('@app/components/PageRoot'))
const TeamPaymentMethods = lazy(() => import('./TeamPaymentMethods'))

class TeamPaymentMethodsWebComponent extends ReactWebComponent {
	static get observedAttributes() {
		return ['team-uuid']
	}

	override render() {
		return (
			<PageRoot>
				<TeamPaymentMethods teamUuid={this.prop('team-uuid')} />
			</PageRoot>
		)
	}
}

customElements.define('team-payment-methods', TeamPaymentMethodsWebComponent)
